module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/store_images/2_c605dad11ca49f866b9f390b7acade55.png";